import { Chip } from "@mui/material";

export default function StatusBadge({ status }) {
  if (!status) return null;

  const normalized = status.toLowerCase();

  let color = "default";
  let label = status;

  if (normalized === "pending") {
    color = "warning";
    label = "Pending";
  } else if (normalized === "completed") {
    color = "success";
    label = "Completed";
  } else if (normalized === "failed") {
    color = "error";
    label = "Failed";
  }

  return (
    <Chip
      label={label}
      color={color}
      size="small"
      variant="filled"
    />
  );
}
